import React from 'react/cjs/react.production.min';

export class FeatureMatrixPriceComponent extends React.Component {
  constructor(bundleConfig) {
    super();

    this.bundleConfig = bundleConfig;

    this.state = {
      currency: null,
      term: null,
      symbol: null,
      price: null
    };

    qs.pricing.onCurrencyPreferenceChanged(() => {
      this.updateState();
    });

    qs.pricing.onTermPreferenceChanged(() => {
      this.updateState();
    });

    this.addToEstimate = this.addToEstimate.bind(this);
  }

  async componentDidMount() {
    await this.updateState();
  }

  async updateState() {
    const productLine = this.bundleConfig.productLine;
    const tier = this.bundleConfig.tier;

    const term = await qs.pricing.getTermPreference();
    const termDescription = term % 12 === 0
      ? `${ term / 12 }-year`
      : `${ this.state.term }-month`;

    const discount = await qs.pricing.getDiscountRate(productLine, tier);
    const maxDiscount = await qs.pricing.getMaxDiscount(productLine, tier);
    let subtext = discount > 0
      ? `Saving ${ Math.round(discount * 100) }% with a ${ termDescription } subscription.`
      : `Save up to ${ Math.round(maxDiscount.percentage * 100) }% by increasing the term.`;

    const prices = await qs.pricing.getBundleStartingPrice(productLine, tier);
    const currency = await qs.pricing.getCurrencyPreference();
    const currencySymbol = qs.pricing.getCurrencySymbol(currency);

    let price = 0;
    let priceSuffix = '';

    if (prices.recurringPrice > 0) {
      price = prices.recurringPrice;
      priceSuffix = '/mo.';
    }
    else {
      price = prices.oneTimePrice;
      priceSuffix = '';
      subtext = 'Choose a subscription plan to unlock discounts.';
    }

    this.setState({
      currencySymbol,
      price,
      priceSuffix,
      subtext,
    });
  }

  addToEstimate() {
    qs.pricing.estimator.addBundle(this.bundleConfig.productLine, this.bundleConfig.tier);
    location.href = '/estimator';
  }

  render() {
    return (
      <div>
        <p className="price-copy mb-0 p-0">
          <em>Starting at</em>
          <span className="price">
            <em><span>{this.state.currencySymbol}</span>{new Intl.NumberFormat().format(Math.round(this.state.price))}</em>
          </span>{this.state.priceSuffix}
        </p>
        {/* <small>{this.state.subtext}</small> */}
        {/* <button type="button" onClick={this.addToEstimate} className="btn btn-small btn-primary mt-4 mb-4">Add to Estimate</button> */}
      </div>
    )
  }
}
